module.exports = __webpack_public_path__ + "static/media/sem-adesao.347e0e91.svg";